export default __webpack_public_path__ + "static/media/christina-wocintechchat-com-L85a1k-XqH8-unsplash.9db67a39.png";